const STORAGE_KEY = 'gf-signup-draft';

export interface SignupDraft {
  communityName: string;
  adminName: string;
  adminEmail: string;
  slugEdited: boolean;
  slugInput: string;
}

export const EMPTY_DRAFT: SignupDraft = {
  communityName: '',
  adminName: '',
  adminEmail: '',
  slugEdited: false,
  slugInput: '',
};

/** Explicitly select draft fields so verification and payment data cannot leak in. */
function draftFields(draft: SignupDraft): SignupDraft {
  return {
    communityName: draft.communityName,
    adminName: draft.adminName,
    adminEmail: draft.adminEmail,
    slugEdited: draft.slugEdited,
    slugInput: draft.slugInput,
  };
}

export function loadSignupDraft(): SignupDraft {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    const parsed: unknown = raw ? JSON.parse(raw) : null;
    if (
      typeof parsed === 'object' &&
      parsed !== null &&
      'communityName' in parsed &&
      typeof parsed.communityName === 'string' &&
      'adminName' in parsed &&
      typeof parsed.adminName === 'string' &&
      'adminEmail' in parsed &&
      typeof parsed.adminEmail === 'string' &&
      'slugEdited' in parsed &&
      typeof parsed.slugEdited === 'boolean' &&
      'slugInput' in parsed &&
      typeof parsed.slugInput === 'string'
    ) {
      return draftFields({
        communityName: parsed.communityName,
        adminName: parsed.adminName,
        adminEmail: parsed.adminEmail,
        slugEdited: parsed.slugEdited,
        slugInput: parsed.slugInput,
      });
    }
  } catch {
    // Storage unavailable or invalid: the form still works with an empty draft.
  }
  return { ...EMPTY_DRAFT };
}

export function saveSignupDraft(draft: SignupDraft): void {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(draftFields(draft)));
  } catch {
    // Storage unavailable: the flow still keeps its draft in memory.
  }
}

export function clearSignupDraft(): void {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage unavailable: clearing must not interrupt a successful signup.
  }
}
